import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { title } from "../config/Config";

// img imports

import choose_img from "../Assets/Images/choose_img.png";

const Result_main = () => {
  return (
    <div className="Choose_sec">
      <Container>
        <Row>
          <Col lg={5}>
            <div className="choose_img">
              <img src={choose_img} alt="choose img" />
            </div>
          </Col>

          <Col lg={7} md={12}>
            <div className="choose_wrapper">
              <h5>Why {title}?</h5>

              <div className="points_list">
                <div className="point">
                  <h6>1. Ancient Wisdom, Modern Wellness</h6>
                  <p>
                    {title} blends age-old healing traditions with
                    today's holistic health needs, nurturing your body, mind,
                    and soul.
                  </p>
                </div>

                <div className="point">
                  <h6>2. Personalized Healing</h6>
                  <p>
                    Discover your unique constitution (prakriti) and enjoy
                    wellness plans tailored just for you — because one size
                    never fits all.
                  </p>
                </div>

                <div className="point">
                  <h6>3. Preventive Care</h6>
                  <p>
                    Focus on long-term balance and vitality with mindful daily
                    habits, seasonal rituals, and natural therapies.
                  </p>
                </div>

                <div className="point">
                  <h6>4. Holistic Harmony</h6>
                  <p>
                    Balance your doshas, elements, and energies for true health
                    that connects mind, body, and spirit.
                  </p>
                </div>

                <div className="point">
                  <h6>5. Trusted Tradition, Innovative Approach</h6>
                  <p>
                    Experience authentic Ayurveda enhanced with modern
                    mindfulness for lasting transformation.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default Result_main;
